module.exports = __webpack_public_path__ + "static/media/basic_helm.fe858c5b.svg";